import { useEffect } from "react";
import { useLocation } from "react-router";
import { logEvent } from "firebase/analytics";
import { analytics } from "~/lib/firebase";

export function usePageView() {
  const location = useLocation();

  useEffect(() => {
    if (!analytics) return;
    logEvent(analytics, "page_view", {
      page_path: location.pathname,
    });
  }, [location.pathname]);
}
